// Belantti cart state request broker (v1.1)
// Coalesces duplicate GET /cart.js reads, keeps the desktop cart badge in sync, and invalidates the short-lived cache on every cart mutation.
(function () {
  if (window.__belanttiCartFetchBrokerV1 || !window.fetch) return;
  window.__belanttiCartFetchBrokerV1 = true;

  var wrappedFetch = window.fetch;
  var cachedResponse = null;
  var cachedAt = 0;
  var inFlight = null;
  var generation = 0;
  var CACHE_MS = 600;

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && input.url) return input.url;
    return '';
  }

  function requestMethod(input, init) {
    var method = init && init.method;
    if (!method && input && input.method) method = input.method;
    return String(method || 'GET').toUpperCase();
  }

  function requestPath(url) {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (error) {
      return String(url || '').split('?')[0].split('#')[0];
    }
  }

  function syncDesktopCartCount(count) {
    count = Math.max(0, parseInt(count, 10) || 0);

    var desktopCart = document.querySelector('.bel-dhm-cart');
    if (!desktopCart) return;

    var badge = desktopCart.querySelector('.bel-dhm-cart-count');

    if (!badge && count > 0) {
      badge = document.createElement('span');
      badge.className = 'bel-dhm-cart-count';
      badge.setAttribute('aria-hidden', 'true');
      desktopCart.appendChild(badge);
    }

    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'inline-flex' : 'none';
    }

    desktopCart.setAttribute(
      'aria-label',
      count > 0 ? 'Basket, ' + count + ' item' + (count === 1 ? '' : 's') : 'Basket'
    );
  }

  function syncCartResponse(response) {
    if (!response || !response.ok) return;

    try {
      response.clone().json().then(function (cart) {
        if (cart && typeof cart.item_count !== 'undefined') {
          syncDesktopCartCount(cart.item_count);
        }
      }).catch(function () {});
    } catch (error) {}
  }

  function isCartStateRequest(url, method) {
    if (method !== 'GET') return false;
    return /(?:^|\/)cart\.js$/.test(requestPath(url));
  }

  function isCartMutation(url, method) {
    if (method === 'GET' || method === 'HEAD') return false;
    return /(?:^|\/)cart\/(?:add|change|update|clear)(?:\.js)?$/.test(requestPath(url));
  }

  function invalidateCartState() {
    generation += 1;
    cachedResponse = null;
    cachedAt = 0;
    // Detach any pre-mutation request so the first post-mutation read starts fresh.
    inFlight = null;
  }

  window.__belanttiInvalidateCartFetchCache = invalidateCartState;
  window.__belanttiSyncDesktopCartCount = syncDesktopCartCount;

  window.fetch = function (input, init) {
    var context = this;
    var args = arguments;
    var url = requestUrl(input);
    var method = requestMethod(input, init);

    if (isCartMutation(url, method)) {
      invalidateCartState();
    }

    if (!isCartStateRequest(url, method)) {
      return wrappedFetch.apply(context, args);
    }

    if (cachedResponse && (Date.now() - cachedAt) <= CACHE_MS) {
      syncCartResponse(cachedResponse);
      try {
        return Promise.resolve(cachedResponse.clone());
      } catch (error) {
        cachedResponse = null;
        cachedAt = 0;
      }
    }

    if (inFlight) {
      return inFlight.then(function (response) {
        return response.clone();
      });
    }

    var requestGeneration = generation;
    var requestPromise = wrappedFetch.apply(context, args).then(function (response) {
      if (response && response.ok && requestGeneration === generation) {
        syncCartResponse(response);
        try {
          cachedResponse = response.clone();
          cachedAt = Date.now();
        } catch (error) {
          cachedResponse = null;
          cachedAt = 0;
        }
      }

      return response;
    });

    inFlight = requestPromise;

    requestPromise.finally(function () {
      if (inFlight === requestPromise) {
        inFlight = null;
      }
    });

    return requestPromise.then(function (response) {
      return response.clone();
    });
  };

  // Keep the cache correct when legacy code mutates the cart through XHR instead of fetch.
  if (window.XMLHttpRequest && !window.__belanttiCartFetchBrokerXhrV1) {
    window.__belanttiCartFetchBrokerXhrV1 = true;

    var xhrProto = window.XMLHttpRequest.prototype;
    var originalOpen = xhrProto.open;
    var originalSend = xhrProto.send;

    xhrProto.open = function (method, url) {
      this.__belanttiCartMutationRequest = isCartMutation(url, String(method || 'GET').toUpperCase());
      return originalOpen.apply(this, arguments);
    };

    xhrProto.send = function () {
      if (this.__belanttiCartMutationRequest) {
        invalidateCartState();
      }
      return originalSend.apply(this, arguments);
    };
  }
})();

// Belantti global cart remove fix (v4.3)
(function () {
  if (window.__belanttiCartRemoveFixV43) return;
  window.__belanttiCartRemoveFixV43 = true;

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format((cents || 0) / 100);
  }

  function updateCartUI(cart) {
    document.querySelectorAll(
      '.enj-cartcost, .mini-cart-total-price, .total-price, [data-cart-total]'
    ).forEach(function (el) {
      el.textContent = formatMoney(cart.total_price || 0);
    });

    document.querySelectorAll(
      '.enj-cartcount, .cart-counter, .cart-count, .count-cart, .js-cart-count, [data-cart-count]'
    ).forEach(function (el) {
      el.textContent = cart.item_count || 0;
    });

    if (window.__belanttiSyncDesktopCartCount) {
      window.__belanttiSyncDesktopCartCount(cart.item_count || 0);
    }
  }

  function renderEmptyMiniCart(miniCart) {
    if (!miniCart) return;

    miniCart.innerHTML = ''
      + '<div class="list_product_minicart empty">'
      + '  <div class="empty-product_minicart">'
      + '    <p class="mb-0">Your shopping bag is empty</p>'
      + '    <a href="/collections/shop-all" class="to-cart">Go to the shop</a>'
      + '  </div>'
      + '</div>';
  }

  function postCartChange(payload) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart remove failed');
      return res.json();
    });
  }

  function setRemoveBusy(btn, isBusy) {
    btn.style.pointerEvents = isBusy ? 'none' : '';
    btn.style.opacity = isBusy ? '0.35' : '';
    btn.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  }

  document.addEventListener('click', function (e) {
    var mainCartRemove = e.target && e.target.closest && e.target.closest('.bel-cart-remove');

    if (mainCartRemove) {
      var itemCard = mainCartRemove.closest('[data-bel-cart-line]');
      var mainLine = itemCard && itemCard.getAttribute('data-bel-cart-line');

      // Preserve the existing href as a no-JS fallback if the line cannot be resolved.
      if (!mainLine) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      setRemoveBusy(mainCartRemove, true);

      postCartChange({
        line: Number(mainLine),
        quantity: 0
      })
        .then(function () {
          window.location.reload();
        })
        .catch(function (err) {
          setRemoveBusy(mainCartRemove, false);

          if (window.console) {
            console.warn('Belantti main cart remove failed', err);
          }
        });

      return;
    }

    var btn = e.target && e.target.closest && e.target.closest('.remove-product');
    if (!btn) return;

    var itemKey = btn.getAttribute('data-key');
    var line = btn.getAttribute('data-line');

    // Preserve any native/fallback remove behaviour if this legacy control has no usable identifier.
    if (!itemKey && !line) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var miniCart = btn.closest(
      '.enj-minicart-ajax, .mini-cart-content, .mini-cart-bottom, .mini-cart, .minicart'
    );

    var row = btn.closest(
      '.minicart_item, .product-mini-cart, .ajaxcart__product, .cart__row, .minicart-item, .mini-cart-item, .ajaxcart__row, li'
    );

    var payload = itemKey
      ? { id: itemKey, quantity: 0 }
      : { line: Number(line), quantity: 0 };

    setRemoveBusy(btn, true);

    postCartChange(payload)
      .then(function (cart) {
        if (row && row.parentNode) {
          row.parentNode.removeChild(row);
        }

        updateCartUI(cart);

        if ((cart.item_count || 0) === 0) {
          renderEmptyMiniCart(miniCart);
        }

        document.dispatchEvent(new CustomEvent('cart:refresh', {
          detail: cart
        }));
      })
      .catch(function (err) {
        setRemoveBusy(btn, false);

        if (window.console) {
          console.warn('Belantti cart remove failed', err);
        }
      });
  }, true);
})();